import { render, staticRenderFns } from "./cooperateOrganizationDetailBox.vue?vue&type=template&id=512c7ebf&scoped=true"
import script from "./cooperateOrganizationDetailBox.vue?vue&type=script&lang=js"
export * from "./cooperateOrganizationDetailBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512c7ebf",
  null
  
)

export default component.exports